<template>
  <div class="modal fade" :id="objectModalName.riskSurvey" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-lg" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.riskSurvey)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">

        <div class="modal-header">
          <div class="row w-100">
            <div class="col-md-7 account d-flex">
              <div>
                <H4 class="mb-0">{{ surveyTitle || 'Fragebogen' }}</H4>
              </div>
            </div>
            <button type="button" class="close xs-close pull-right" data-dismiss="modal" @click="closeWarning('#'+objectModalName.riskSurvey)">×</button>
          </div>

        </div>

        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h4 class="dkl-h4">Allgemein</h4>

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">Verarbeitungstätigkeit<span class="text-danger">*</span></label>
                      <div>
                        <select class="form-control select select-vt select-single" v-model="riskAnalysis.vt" v-select2>
                          <option v-for="vt in vts" :key="vt.id" :value="vt.id">{{vt.name}}</option>
                        </select>
                      </div>
                      <span class="error-message text-danger" v-show="v$.riskAnalysis.vt.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">Grund der Risikobewertung</label>
                      <textarea class="form-control" v-model="riskAnalysis.reason" placeholder="Grund der Risikobewertung" autocomplete="off"></textarea>
                    </div>
                  </div>
                </div>
              </div> <!-- end row -->
              <SurveyComponent :survey-json="surveyJson" :surveyID="surveyID" :resetSurvey="resetSurvey" @surveyCompleted="surveyCompleted" v-if="Object.keys(surveyJson).length>0" :survey-result="surveyResult"></SurveyComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import service from '@/utils/request.js';
import {ajaxErrorMessage, closeWarning, initSelect2} from '@/utils/index.js';
import {newRiskAnalysis, objectModalName, categoryChoices, personNumberChoices} from "@/utils/enums";
import SurveyComponent from '@/components/component/SurveyComponent.vue';
import {useVuelidate} from "@vuelidate/core";
import {required} from "@vuelidate/validators";

export default {
  name: 'SimpleRiskAnalysisComponent',
  components: {
    SurveyComponent,
  },
  props: {
    surveyJson: Object,
    resultUploadUrl: String,
    surveyID: Number,
    surveyTitle: String,
    surveyResult: Object,
    riskAnalysis: {
      type: Object,
      default: () => newRiskAnalysis
    },
  },
  data: function() {
    return {
      loading: true,
      resultBody: {},
      objectModalName: objectModalName,
      resetSurvey: false,
      riskScore: {
        'question1': {
          category: 'Datenschutz',
          score: {
              'Item 1': 1,
              'Item 2': 1,
              'Item 3': 2,
              'Item 4': 3,
            }
          },
        'question2': {
          category: 'Datenschutz',
          score:{
              'Item 1': 1,
              'Item 2': 1,
              'Item 3': 2,
              'Item 4': 3,
            }
          },
        'question3': {
          category: 'Datenschutz',
          score: {
              'Item 1': 1,
              'Item 2': 1,
              'Item 3': 2,
              'Item 4': 2,
              'Item 5': 3,
            }
          },
        'question4': {
          category: 'Datenschutz',
          score:{
              'Item 1': 1,
              'Item 2': 1,
              'Item 3': 2,
              'Item 4': 2,
              'Item 5': 3,
            }
          },
        'question5': {
          category: 'IT',
          score: {
            'Item 1': 1,
            'Item 2': 2,
            'Item 3': 3,
          },
        },
      }
    }
  },
  created() {
  },
  validations() {
    return {
      riskAnalysis: {
        vt: {required, $lazy: true},
      },
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  computed: {
    ...mapGetters(['accountid', 'accountName', 'username', 'id']), ...mapState({customerAddress: state => state.account.address, vts: state => state.data.vts,}),
  },
  mounted() {
    initSelect2()
    $('#'+objectModalName.riskSurvey).on('hidden.bs.modal', () => {
      this.resetSurvey = true
    })
    $('#'+objectModalName.riskSurvey).on('shown.bs.modal', () => {
      $(`#${objectModalName.riskSurvey} .select-vt`).val(this.riskAnalysis.vt).trigger('change')
    })
  },
  methods: {
    closeWarning,
    surveyCompleted: function(result) {
      this.$emit('simpleRiskAnalysisResult', result)
      this.resultBody = result
      this.calculateRiskScore(result)
      this.saveRiskAnalysisNoExit((riskAnalysis) => {
        this.v$.$reset()
        if (this.resultUploadUrl) this.submitResult(this.resultUploadUrl)
        this.$emit('simpleRiskAnalysisCompleted', {riskAnalysis: riskAnalysis, dataTypeCategory: categoryChoices[result['question1']], numberOfPersons: personNumberChoices[result['question2']]})
        this.$vToastify.success('Risikobewertung ist erfolgreich gespeichert!')
      })
    },
    submitResult: function(submitUrl) {
      const uploadResult = {
        survey: this.surveyID,
        mandant: this.accountid,
        result_body: this.resultBody,
        createdby: this.id,
      }
      service.request({
        url: submitUrl,
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: uploadResult
      }).then((response) => {
        this.riskAnalysis = response.data
        this.$vToastify.success('Ergebnisse erfolgreich hochgeladen. Bericht wird erstellt!')
        this.$emit('surveyResultSubmitted', response.data)
      }).catch(function(err) {
        console.log(err)
      })
    },
    calculateRiskScore(result) {
      let bsiScore = []
      let dsgvoScore = []
      Object.keys(result).forEach((key) => {
        if (this.riskScore[key]) {
          if (this.riskScore[key].category === 'Datenschutz') {
            dsgvoScore.push(this.riskScore[key].score[result[key]])
          } else {
            bsiScore.push(this.riskScore[key].score[result[key]])
          }
        }
      })
      this.riskAnalysis.bsi_basis = Math.max(...bsiScore)
      this.riskAnalysis.dsgvo_basis = Math.max(...dsgvoScore)
    },
    async saveRiskAnalysisNoExit(callback) {
      const isValid = await this.v$.riskAnalysis.$validate()
      if (!isValid) {
        this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
        return false
      }
      const newRiskAnalysis = this.riskAnalysis.id == null ? true : false
      let url = 'todos/v1/create_risk_analysis/'
      if (!newRiskAnalysis) url = `todos/v1/update_risk_analysis/${this.riskAnalysis.id}/`
      this.riskAnalysis.modified_by = this.username
      service.request({
        url: url,
        method: 'POST',
        responseType: 'json',
        data: this.riskAnalysis
      }).then((response) => {
        if (callback && typeof callback === 'function') callback(response.data)
      }).catch(error => this.$vToastify.error(ajaxErrorMessage(error)))
    },
  }
}
</script>

<style scoped>
.close {
  right: 25px;
  top: 20px;
}
</style>
